export default __webpack_public_path__ + "static/media/CompoundWords_25.d313023b.png";